import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, getDocs, query, where } from 'firebase/firestore';
import './Reservas.css';


function Reservas({ id }) {
  const [sedes, setSedes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSedes = async () => {
      try {
        const q = query(collection(db, 'reservasSedes')); // Fetch all sedes
        const querySnapshot = await getDocs(q);
        const sedesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        const isSedeOpen = (sede) => {
          if (sede.activationType === 'scheduled') {
            if (!sede.schedule) return false;

            const now = new Date();
            const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
            const currentDay = days[now.getDay()];
            const currentTime = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');

            const daySchedule = sede.schedule[currentDay];
            if (!daySchedule || daySchedule.length === 0) {
              return false;
            }

            for (const slot of daySchedule) {
              if (currentTime >= slot.start && currentTime <= slot.end) {
                return true;
              }
            }
            return false;
          } else { // Defaults to manual
            return sede.isActive;
          }
        };

        const visibleSedes = sedesData.filter(isSedeOpen);
        setSedes(visibleSedes);

      } catch (err) {
        setError('Failed to load locations.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSedes();
  }, []);

  const handleSelectSede = (sedeId) => {
    navigate(`/reservas/${sedeId}`);
  };

  const reservasStyle = {
    backgroundImage: `url('/fondosedes.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'white',
    padding: '50px 20px',
    textAlign: 'center'
  };

  if (loading) return <section id={id}><p>Loading locations...</p></section>;
  if (error) return <section id={id}><p>Error: {error}</p></section>;

  return (
    <section id={id} className="reservas-section" style={reservasStyle}>
      <div className="reservas-content is-visible">
        <h2>Reservas</h2>
        <p>Selecciona una de nuestras sedes para continuar con tu reserva:</p>
        <div className="sedes-grid">
          {sedes.map(sede => (
            <Link to={`/reservas/${sede.id}`} key={sede.id} className="sede-card-link">
              <div className="sede-card" style={{ backgroundImage: `url(${sede.imageUrl})` }}>
                <div className="sede-card-overlay">
                  <h3>{sede.title}</h3>
                  <button className="sede-card-button">Reservar</button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reservas;